import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { stLedgerEntries } from '../../../services/socialTradingService';

const RESOURCE = Resources.socialTradingRedpacketPlatformLedger;

const PLATFORM_DIRS = new Set([
  'RESERVE',
  'CLAIM_RELEASE',
  'REFUND',
  'EXPIRY_REFUND',
  'BUDGET_ADJUST',
  'USER_FUND',
]);

/** Platform-side ledger (scope=PLATFORM). Optional DB direction filter. */
export const redpacketPlatformLedgerDataProvider: CustomDataProvider = {
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== RESOURCE) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }
    const { page = 1, perPage = 20 } = params.pagination || {};
    const raw = ((params.filter?.direction as string | undefined) || '').toUpperCase();
    const direction = raw && PLATFORM_DIRS.has(raw) ? raw : undefined;
    const packetId = (params.filter?.packetId as string | undefined) || undefined;
    const roomId = (params.filter?.roomId as string | undefined) || undefined;
    const roomName = (params.filter?.roomName as string | undefined) || undefined;
    const res = await stLedgerEntries({
      scope: 'PLATFORM',
      direction,
      packetId,
      roomId,
      roomName,
      limit: perPage,
      offset: (page - 1) * perPage,
    });
    const items = res?.items || [];
    return {
      data: items.map((row) => ({ ...row, id: row.id })),
      total: res?.total ?? items.length,
    };
  },
};
